import { Controller } from "@hotwired/stimulus"
import { enter, leave } from "el-transition"

// Connects to data-controller="slider"
export default class extends Controller {
	static targets = ["button", "content"]

	connect() {
		// Action zu den Button hinzufügen
		this.buttonTargets.forEach((button) => (button.dataset.action = "click->slider#slide"))
	}

	slide({ currentTarget }) {
		// UI-Aktiv umstellen
		this.buttonTargets.forEach((button) => button.removeAttribute("data-ui"))
		currentTarget.dataset.ui = "aktiv"

		// Content sichtbar machen
		const buttonIndex = this.buttonTargets.indexOf(currentTarget)

		this.contentTargets.forEach((content) => content.classList.add("hidden"))

		enter(this.contentTargets[buttonIndex])

		// Bei Textarea Fokus setzen (Bemerkungen)
		this.focus_textarea(this.contentTargets[buttonIndex])

		this.dispatch("changed", { detail: { index: buttonIndex } })
	}

	// Private Methods
	focus_textarea(content) {
		const textarea = content.querySelector("trix-editor")
		if (textarea) {
			textarea.editor.setSelectedRange([0, 0])
		}
	}
}
